export interface Module {
  num: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Golf Player Assessment System™',
    description:
      'Ready-to-use assessments for putting, short game, wedges, irons, driving, ball flight, course management, player goals, practice habits, and progress. Quickly identify what each golfer needs and what to coach next.',
  },
  {
    num: '2',
    title: 'Golf Drill Library™',
    description:
      'An organized library for putting, chipping, pitching, bunkers, wedges, irons, driving, full swing, distance control, and performance — with setup, objective, coaching points, progressions, regressions, and success criteria ready.',
  },
  {
    num: '3',
    title: 'Ready-to-Coach Session Plans™',
    description:
      'Complete sessions you can take directly into your lessons. Choose the objective and get the structure, activities, drills, progressions, challenges, coaching points, and player practice already organized.',
  },
  {
    num: '4',
    title: 'Player Development Programs™',
    description:
      'Turn individual lessons into structured development. Use ready-made pathways for different golfers, scoring goals, putting, short game, ball striking, driving, course management, juniors, and competitive players.',
  },
  {
    num: '5',
    title: 'Practice & Performance Builder™',
    description:
      'Give players clear practice instead of vague instructions. Use ready-made 15, 30, 45, and 60-minute plans for different skills, with tasks, targets, scoring, progressions, and tracking.',
  },
  {
    num: '6',
    title: 'Coaching Progress & Session Toolkit™',
    description:
      'Lesson planners, coaching notes, goal sheets, practice prescriptions, progress trackers, player reviews, reassessments, and next-session planning — ready to use and personalize.',
  },
]

export const promises = [
  'Assess players faster.',
  'Select the right drills.',
  'Use complete sessions.',
  'Build player progressions.',
  'Assign structured practice.',
  'Track development.',
]
